<template>
	<div class="auth-container">
		<div class="auth-wrapper">
			<!-- Left Section - Project Selection -->
			<div class="auth-form-section">
				<div class="mobile-header">
					<img class="mobile-logo" :src="require('@/assets/images/brand/lema-logo-color.svg')" alt="Lema" />
				</div>

				<div class="auth-card">
					<div class="auth-header">
						<h1 class="auth-title">انتخاب پروژه</h1>
						<p class="auth-subtitle">
							لطفاً یکی از پروژه‌های زیر را انتخاب کنید
						</p>
					</div>

					<div class="project-container">
						<div
							@click="selectedProject(projects.project.id)"
							class="project-card"
							v-for="projects in projectList"
							:key="projects.id"
						>
							<div class="project-image-container">
								<img class="project-image" :src="projects.project.image" :alt="projects.project.name_fa" />
								<div class="project-overlay">
									<div class="project-select-btn">
										<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
									</div>
								</div>
							</div>
							<div class="project-info">
								<h3 class="project-name">{{ projects.project.name_fa }}</h3>
								<p class="project-description">برای شروع کار روی این پروژه کلیک کنید</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Right Section - Brand -->
			<div class="auth-brand-section">
				<div class="brand-content">
					<img class="brand-logo" :src="require('@/assets/images/brand/lema-logo-white.svg')" alt="Lema" />
					<h2 class="brand-title">به پنل مدیریت لما<br />خوش آمدید</h2>
					<p class="brand-desc">پروژه موردنظر را انتخاب کنید تا فضای مدیریت شبکه پذیرندگان باز شود.</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			projectList: [],
		};
	},
	mounted() {
		this.getProjectList();
	},
	methods: {
		async getProjectList() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.PROJECT_LISTS +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.projectList = res.data;
				this.projectList;
			}
		},
		selectedProject(id) {
			this.$STORE.commit('userConfig/setProjectInfo', id);
			this.$router.push({ name: 'dashboard' });
		},
	},
};
</script>

<style scoped>
/* Main Container */
.auth-container {
	min-height: 100vh;
	background: linear-gradient(145deg, #1a2332 0%, #223047 48%, #1a2332 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
}

.auth-wrapper {
	display: flex;
	width: 100%;
	max-width: 1200px;
	min-height: 600px;
	background: #ffffff;
	border-radius: 24px;
	box-shadow: 0 40px 100px rgba(0, 0, 0, 0.5);
	overflow: hidden;
}

/* Form Section */
.auth-form-section {
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 60px;
	background: rgba(255, 255, 255, 0.9);
}

.mobile-header {
	display: none;
	text-align: center;
	margin-bottom: 40px;
}

.mobile-logo {
	height: 60px;
	width: auto;
}

.auth-card {
	max-width: 500px;
	margin: 0 auto;
	width: 100%;
}

.auth-header {
	text-align: center;
	margin-bottom: 40px;
}

.auth-title {
	font-size: 32px;
	font-weight: 700;
	color: #2d3748;
	margin-bottom: 16px;
	line-height: 1.2;
}

.auth-subtitle {
	font-size: 16px;
	color: #718096;
	line-height: 1.5;
	margin: 0 0 16px 0;
}

/* Project Container */
.project-container {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
	gap: 24px;
	max-height: 70vh;
	overflow-y: auto;
	padding: 8px;
}

.project-container::-webkit-scrollbar {
	width: 8px;
}

.project-container::-webkit-scrollbar-track {
	background: #f1f1f1;
	border-radius: 4px;
}

.project-container::-webkit-scrollbar-thumb {
	background: linear-gradient(#3aa6a6, #2d8b8b);
	border-radius: 4px;
}

.project-container::-webkit-scrollbar-thumb:hover {
	background: #2d8b8b;
}

/* Project Cards */
.project-card {
	background: white;
	border-radius: 20px;
	overflow: hidden;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
	transition: all 0.3s ease;
	cursor: pointer;
	border: 2px solid transparent;
}

.project-card:hover {
	transform: translateY(-8px);
	box-shadow: 0 12px 40px rgba(45, 139, 139, 0.18);
	border-color: rgba(45, 139, 139, 0.35);
}

.project-image-container {
	position: relative;
	width: 100%;
	height: 200px;
	overflow: hidden;
}

.project-image {
	width: 100%;
	height: 100%;
	object-fit: cover;
	transition: transform 0.3s ease;
}

.project-card:hover .project-image {
	transform: scale(1.05);
}

.project-overlay {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: linear-gradient(135deg, rgba(45, 139, 139, 0.86) 0%, rgba(34, 48, 71, 0.86) 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	opacity: 0;
	transition: opacity 0.3s ease;
}

.project-card:hover .project-overlay {
	opacity: 1;
}

.project-select-btn {
	width: 60px;
	height: 60px;
	background: white;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #2d8b8b;
	transform: scale(0.8);
	transition: transform 0.3s ease;
}

.project-card:hover .project-select-btn {
	transform: scale(1);
}

.project-info {
	padding: 24px;
	text-align: center;
}

.project-name {
	font-size: 18px;
	font-weight: 600;
	color: #2d3748;
	margin: 0 0 8px 0;
	line-height: 1.3;
}

.project-description {
	font-size: 14px;
	color: #718096;
	margin: 0;
	line-height: 1.4;
}

/* Brand Section — Lema dark navy */
.auth-brand-section {
	flex: 0 0 42%;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 48px;
	background:
		radial-gradient(120% 80% at 100% 0%, rgba(58, 166, 166, 0.16), transparent 55%),
		radial-gradient(120% 80% at 0% 100%, rgba(45, 139, 139, 0.2), transparent 55%),
		linear-gradient(160deg, #223047 0%, #1a2332 100%);
	border-left: 1px solid rgba(255, 255, 255, 0.08);
}

.brand-content {
	text-align: center;
	color: #eaf1fb;
}

.brand-logo {
	width: 178px;
	height: auto;
	margin-bottom: 30px;
	filter: drop-shadow(0 12px 30px rgba(58, 166, 166, 0.35));
}

.brand-title {
	font-size: 28px;
	font-weight: 700;
	margin-bottom: 16px;
	line-height: 1.5;
}

.brand-desc {
	font-size: 14px;
	line-height: 2;
	color: #a9b8d0;
	margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
	.auth-container {
		padding: 10px;
		background: #f7fafc;
	}

	.auth-wrapper {
		flex-direction: column;
		min-height: 100vh;
		border-radius: 0;
		max-width: none;
		box-shadow: none;
		background: white;
	}

	.auth-brand-section {
		display: none;
	}

	.mobile-header {
		display: block;
	}

	.auth-form-section {
		padding: 40px 24px;
		justify-content: flex-start;
		padding-top: 60px;
	}

	.auth-title {
		font-size: 24px;
	}

	.auth-subtitle {
		font-size: 14px;
	}

	.project-container {
		grid-template-columns: 1fr;
		gap: 16px;
		max-height: 60vh;
	}

	.project-card {
		border-radius: 16px;
	}

	.project-image-container {
		height: 160px;
	}

	.project-info {
		padding: 20px;
	}

	.project-name {
		font-size: 16px;
	}

	.project-description {
		font-size: 13px;
	}
}

@media (max-width: 480px) {
	.auth-form-section {
		padding: 30px 20px;
	}

	.project-container {
		max-height: 50vh;
	}

	.project-image-container {
		height: 140px;
	}

	.project-info {
		padding: 16px;
	}
}

/* Focus styles */
textarea:focus,
input:focus {
	outline: none;
}
</style>
